import apiRequest from "../../helpers/apiRequest";

export default async () => {
    const res = await apiRequest({
        method: 'get',
        url: `accounts/users/user-info/`,
    });
    return res.data
}
